module.exports = __webpack_public_path__ + "static/media/2Ringgit.7fe7d3d8.JPG";